import { getContactFormTemplate, getVueContactTemplate } from "../../shortcodes/templates";

let contactForm = null;
const visualizeContactFormComponent = content => {
  contactForm = content.querySelectorAll('[data-tiny-mce-component="contactform"]')[0];
  if (contactForm) {
    contactForm.outerHTML = getContactFormTemplate();
  }
};

const serializeContactFormComponent = content => {
  const contactWidget = content.querySelectorAll('[data-tiny-mce-component="contactform"]')[0];
  if (contactWidget) {
    content.querySelectorAll('[data-tiny-mce-component="contactform"]')[0].innerHTML = getVueContactTemplate();
  }
};

export { visualizeContactFormComponent, serializeContactFormComponent };
